
import { HttpService } from '../common/http/http.service';
import { Path } from "../../../app.config";
import { GroupSearchCriteria } from "../../../model/group/groupSearchCriteria.model";
import { SearchCriteria } from "../../../model/common/grid";
import { Group } from "../../../model/group/group.model";

export class GroupService {
    private httpsSrv: HttpService;

    public static $inject: Array<string> = ["HttpService"];
    constructor(httpsService: HttpService) {
        this.httpsSrv = httpsService;
    }

    getGroupListWithSearchCriteria(ceid: number, gridArg: GroupSearchCriteria) {
        var options = { url: Path.APIUrl.GetAllGroupsWithSearchCriteriaUrl(), method: "POST", data: { ceid: ceid, param: gridArg } };
        return this.httpsSrv.execute(options);
    }

    getGroupList(ceid: number) {
        var options = { url: Path.APIUrl.GetAllGroupsUrl(), params: { ceid: ceid } };
        return this.httpsSrv.get(options);
    }

    getGroupDetails(ceid: number,groupId: number) {
        var options = { url: Path.APIUrl.GetGroupDetails(), params: { ceid: ceid, groupId: groupId } };
        return this.httpsSrv.get(options);
    }

    getAllCityCSList(ceid: number) {
        var options = { url: Path.APIUrl.GetAllCityCSUrl(), params: { ceid: ceid } };
        return this.httpsSrv.get(options);
    }

    getAllTimeZones() {
        var options = { url: Path.APIUrl.GetAllTimeZonesUrl() };
        return this.httpsSrv.get(options);
    }

    saveGroup(groupDetails: Group) {
        var opt = { url: Path.APIUrl.SaveGroupUrl(), method: "POST", data: { group: groupDetails } };
        return this.httpsSrv.execute(opt);
    }

    deleteGroup(ceid: number, groupId: number, newGroupId: number) {
        var opt = { url: Path.APIUrl.DeleteGroupUrl(), method: "POST", data: { ceid: ceid, groupId: groupId, newGroupId: newGroupId } };
        return this.httpsSrv.execute(opt);
    }

    getAllUsersForAGroup(searchCriteria: SearchCriteria, groupId: number, ceid: number) {        
        var opt = { url: Path.APIUrl.GetAllUsersForGroupUrl(), method: "POST", data:  { param: searchCriteria, groupId: groupId, ceid: ceid} };
        return this.httpsSrv.execute(opt);
    }

}